import styled from "styled-components";
import { Backdrop, CircularProgress } from "@mui/material";

import { theme } from "./colors";

export const Background = styled.div`
  width: 100%; /* Nunca use 100vw, isso é o que cria a linha branca! */
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #d37228; /* Mantém a sua cor laranja */
  overflow: hidden; /* Corta qualquer coisa que tente criar scroll na tela de login */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
`;

export const BackgroundApp = styled.div`
  width: 100%; /* Nunca use 100vw para evitar a linha branca lateral */
  height: 100vh;
  /* dvh desconta a barra de endereço do navegador no celular (100vh não) */
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Trava qualquer vazamento ou rolagem indesejada na tela inteira */
  box-sizing: border-box;
  background-color: #f7f9fc; /* Um fundo cinza BEM clarinho para destacar os cards */
`;

/* export const BodyContainer = styled.div`
  width: 100vw;
  height: 80vh;
  @media (max-height: 800px) {
    height: 75vh;
  }
  @media (max-height: 700px) {
    height: 74vh;
  }
`; */
export const BodyContainer = styled.div`
  width: 100%;
  flex: 1; /* Preenche todo o espaço que sobra entre o Header e o final da tela */
  overflow-y: auto; /* Ativa a rolagem vertical apenas aqui dentro */
  overflow-x: hidden; /* Impede a rolagem horizontal (linha branca) */
  box-sizing: border-box;
  /* Dá espaço no final para o Menu Flutuante não cobrir o último item
     (+ área segura do iPhone com barra de gesto) */
  padding-bottom: calc(110px + env(safe-area-inset-bottom));

  /* Esconde a barra de rolagem visualmente, mas mantém o funcionamento (opcional, fica mais limpo) */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const NavContainer = styled.div`
  /* Apenas um wrapper, não precisa de muito estilo pois a NavBar já é fixed */
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100vw;
  height: 100px;
  background-color: ${theme.colors.base};
`;
export const BackdropMui = styled(Backdrop)``;

export const CircularProgressMui = styled(CircularProgress)``;
